export enum Ecosystem {
  EVM = "evm",
  SOLANA = "solana",
  SUI = "sui",
}
